export const REQUEST_SYSTEM_MESSAGES = 'dt/systemMessages/REQUEST_SYSTEM_MESSAGES';
export const RECEIVE_SYSTEM_MESSAGES = 'dt/systemMessages/RECEIVE_SYSTEM_MESSAGES';
export const DISMISS_SYSTEM_MESSAGE = 'dt/systemMessages/DISMISS_SYSTEM_MESSAGE';

export const requestSystemMessages = () => ({
  type: REQUEST_SYSTEM_MESSAGES,
});

export const dismissSystemMessage = (id) => ({
  type: DISMISS_SYSTEM_MESSAGE,
  systemMessageId: id,
});

export const receiveSystemMessages = (systemMessages) => ({
  type: RECEIVE_SYSTEM_MESSAGES,
  systemMessages,
});
